import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import { ReactElement } from 'react';

interface InfoLabelProps {
  label: string;
  description: string;
}

export default function InfoLabel({ label, description }: InfoLabelProps): ReactElement {
  return (
    <Box alignItems="center" component="span" display="inline-flex" gap={0.5}>
      <span>{label}</span>
      <Tooltip title={description}>
        <InfoOutlinedIcon fontSize="inherit" sx={{ color: 'text.secondary' }} />
      </Tooltip>
    </Box>
  );
}
